import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SynchroState {
  [synchroName: string]: number;
}

const initialState: SynchroState = {
  INITIAL_NAME: 0,
};

const synchroSlice = createSlice({
  name: "synchroNumber",
  initialState,
  reducers: {
    setSynchroNumber: (
      state,
      action: PayloadAction<{ synchroName: string; synchroNumber: number }>
    ) => {
      state[action.payload.synchroName] = action.payload.synchroNumber;
    },
    removeSynchroNumber: (state, action: PayloadAction<string>) => {
      delete state[action.payload];
    },
  },
});

export const { /*setSynchroNumber ,*/ removeSynchroNumber } = synchroSlice.actions;
export default synchroSlice.reducer;
